module.exports = __webpack_public_path__ + "img/image2.36b5ca37.jpg";